import React, { useState, useEffect } from 'react';
import { withFormik, Field, Form, getIn } from 'formik';
import { Button, Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import { FormikRangePicker, FormikSelect } from '../../../components';
import { debounceIndexCompanyTaskRequest } from '../../../requests/companyTasks';

const formatDate = date => {
  if (typeof date.format === 'function') return date.format('DD-MM-YYYY');
  if (typeof date === 'string') return date.replace(/\//g, '-');
  return date;
};

const BossTasksFilter = props => {
  const { errors, touched, setFieldValue, values, employees } = props;
  const dispatch = useDispatch();
  const [tasks, setTasks] = useState([]);
  const [loadingTasks, setLoadingTasks] = useState(false);

  const priorityOptions = [
    { label: 'Alta', value: 2 },
    { label: 'Media', value: 1 },
    { label: 'Baja', value: 0 }
  ];

  const fetchTasksByRange = dateRange => {
    if (!dateRange || dateRange.length < 2 || !dateRange[0] || !dateRange[1]) return;
    setLoadingTasks(true);
    const dateRangeParam = `${formatDate(dateRange[0])},${formatDate(dateRange[1])}`;
    debounceIndexCompanyTaskRequest({
      dispatch,
      params: { display_length: 1000, date_range: dateRangeParam },
      successCallback: response => {
        const mappedTasks = response.data.data.map(task => ({ id: task.id, label: task.title, value: task.title }));
        const uniqueTasks = Array.from(new Map(mappedTasks.map(item => [item.value, item])).values());
        setTasks(uniqueTasks);
      },
      callback: () => setLoadingTasks(false)
    });
  };

  useEffect(() => {
    if (values.dateRange && values.dateRange.length === 2 && values.dateRange[0] && values.dateRange[1]) {
      fetchTasksByRange(values.dateRange);
    } else {
      setTasks([]);
      setFieldValue('filterTitle', '');
    }
    // eslint-disable-next-line
  }, [values.dateRange]);

  return (
    <Form className="absence-filter-form pt-2 px-3 mt-2">
      <Row>
        <Col xs={12} md={3}>
          <Field name="dateRange">
            {({ field }) => (
              <FormikRangePicker
                {...field}
                name={field.name}
                abbr
                label="Periodo (Fecha de Inicio)"
                required
                startDateName="startDate"
                endDateName="endDate"
                startDate={values.startDate}
                endDate={values.endDate}
                showClearDates
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
                appendToBody
                repositionPickerOnUpdate
              />
            )}
          </Field>
        </Col>
        <Col xs={12} md={3}>
          <Field name="filterEmployee">
            {({ field }) => (
              <FormikSelect
                {...field}
                label="Colaboradores"
                options={employees}
                placeholder=""
                onChange={data => setFieldValue(field.name, data ? data.value : '')}
                isClearable
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col xs={12} md={3}>
          <Field name="filterTitle">
            {({ field }) => (
              <FormikSelect
                {...field}
                label="Tarea"
                options={tasks}
                placeholder=""
                onChange={data => setFieldValue(field.name, data ? data.value : '')}
                isClearable
                isDisabled={!values.dateRange || values.dateRange.length !== 2 || loadingTasks}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col xs={12} md={3}>
          <Field name="filterPriority">
            {({ field }) => (
              <FormikSelect
                {...field}
                label="Prioridad"
                options={priorityOptions}
                placeholder=""
                onChange={data => setFieldValue(field.name, data ? data.value : '')}
                isClearable
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>
      <Row className="my-3">
        <Col xs={12} md={{ span: 2, offset: 10 }} className="d-flex align-items-end justify-content-end">
          <Button type="submit" className="btn-block btn-primary mb-3">
            FILTRAR
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

const filterInitialValues = () => ({
  dateRange: [],
  filterEmployee: '',
  filterTitle: '',
  filterPriority: ''
});

const filterValidationSchema = Yup.object().shape({
  dateRange: Yup.array()
    .required('Debes seleccionar un rango de fechas')
    .rangedate(true)
});

const filterHandleSubmit = (values, { props }) => props.formRequest(values);

export default withFormik({
  mapPropsToValues: filterInitialValues,
  validationSchema: filterValidationSchema,
  handleSubmit: filterHandleSubmit,
  enableReinitialize: true
})(BossTasksFilter);
